var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "card-body position-relative p-0",
      attrs: { id: "referrers-select-container" },
    },
    [
      _c("div", { class: _vm.spaceClasses }, [
        _vm.firstTimeLoading
          ? _c(
              "div",
              [_vm.firstTimeLoading ? _c("inline-loader") : _vm._e()],
              1
            )
          : _c(
              "div",
              { staticClass: "mb-3" },
              [
                _c("v-select-field", {
                  staticClass: "search-input w-100",
                  attrs: {
                    placeholder: _vm.$t("global.actions.searchReferrers"),
                    label: "fullName",
                    "remove-duplicates-by": "id",
                    options: _vm.referrers,
                    clearable: true,
                    autoscroll: false,
                    filterable: false,
                    "referrers-checkboxes": _vm.hasCheckboxes,
                    "search-min-characters": 2,
                    "infinite-scroll-mode": "",
                    "loading-more-stop": !!_vm.allReferrersLoaded,
                    "loading-options":
                      _vm.loadingStates.searchingReferrers ||
                      _vm.loadingStates.loadingMoreReferrers,
                    loading: _vm.loadingStates.loadingReferrers,
                    scenario: _vm.scenario,
                    multiple: _vm.multiple,
                    "default-value": _vm.defaultValueComputed,
                    "extra-select-data": _vm.extraSelectData,
                    action: _vm.actionRef,
                    "deselect-from-dropdown": "",
                    "delete-options": true,
                    "no-options-text": _vm.$t("global.phrases.noResultsFound"),
                  },
                  on: {
                    "option:selected": _vm.handleChange,
                    "option:deselected": _vm.handleDeselect,
                    clear: _vm.handleClearReferrer,
                    search: _vm.handleSearchReferrer,
                    "load-more": _vm.loadMoreReferrers,
                  },
                }),
              ],
              1
            ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }